import React, { useState, useEffect } from "react";
import apiManager from "../../utils/apiManager";
import {
  AllCategoryBlogAPI,
  tagsListAPI,
  categoryTagsListAPI,
} from "../../../public/constants/constants";
import CategoryData from "./categoryData";
import Pagination from "./pagination";
import "../../../public/styles/blog/exploreMore.scss";

function ExploreMore(props) {
  const [totalNumberOfPages, setTotalNumberOfPages] = useState(1);
  const [perPage, setPerpage] = useState(6);
  const [currPage, setCurrPage] = useState(1);
  const [postDataAll, setPostDataAll] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [blogToShow, setBlogsToShow] = useState([]);
  const [selectedCategoryData, setSelectedCategoryData] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [selectedTagList, setSelectedTagList] = useState([]);
  const [tagsList, setTagsList] = useState([]);
  const [sortingType, setSortingType] = useState("ALL");

  useEffect(
    () => {
      if (props.isFromCategoryPage && postDataAll.length>0) {
        selectCategory(props.categoryName);
      }
      else if (props.isTrendingBlogs) {
        calculateFilteredData(props.trendingBlogs);
        setPostDataAll(props.trendingBlogs);
      }
    },
    [props.categoryName, props.trendingBlogs , postDataAll]
  );

  const selectCategory = value => {
    getCategoryTagsList(value.replaceAll(" ", "-").toLowerCase());
    setSelectedCategory(value);
    setSelectedTagList([]);
    filterByCategory(value);
  };



  const calculateTopCategoryData = listItems => {
    const listItems2 = listItems;
    const mostViewed30 = [null, null, null];
    const mostViewed60 = [null, null, null];


    for (let i = 0; i < 3; i++) {
      let brandPlug;
      let tempIndex;
      let tempIndex1;
      const selcetedIndices = [];
      if (i == 0) {
        brandPlug = 'true';  // when i=0 means in first coloumn brand plug should be true
      } else {
        brandPlug = 'false';  // when i!=0 means in second and third coloumn brand plug should be false
      }
      listItems2.map((blog, index) => {
        if ((blog.brand_plug == brandPlug && blog.trending_plug == "true") && (mostViewed30[i] === null || blog.post_count_30 > mostViewed30[i].post_count_30)) {
          mostViewed30[i] = blog;
          tempIndex = index;
        }
        else if ((blog.brand_plug == brandPlug && blog.trending_plug == "false") && (mostViewed60[i] === null || blog.post_count_60 > mostViewed60[i].post_count_60)) {
          mostViewed60[i] = blog;
          tempIndex1 = index;
        }
      });
      if (tempIndex != undefined) {
        selcetedIndices.push(tempIndex);
      }
      if (tempIndex1 != undefined) {
        selcetedIndices.push(tempIndex1);
      }
      console.log(listItems2, 'listItems2');
      if (selcetedIndices.length > 0) {
        selcetedIndices.sort();
        for (let j = selcetedIndices.length - 1; j >= 0; j--)
          listItems2.splice(selcetedIndices[j], 1);
      }
      console.log(listItems2, 'listItems2', selcetedIndices);
    }
    const listItemsOrder = [...mostViewed30, ...mostViewed60, ...listItems2].filter(element => element !== null);
    calculateFilteredData(listItemsOrder);
  }


  const filterByCategory = selectedCategory => {
    if (selectedCategory == "All") {
      calculateTopBlogsAll(postDataAll);
    } else {
      const listItems = [];
      postDataAll.map(blog => {
        if (blog.categories && Array.isArray(blog.categories)) {
          const result = blog.categories.filter(
            elm =>
              elm.replaceAll(" ", "-").toLowerCase() ===
              selectedCategory.replaceAll(" ", "-").toLowerCase()
          );
          if (result.length > 0) {
            listItems.push(blog);
          }
        }
      });
      // console.log("listItems = ",listItems , postDataAll);
      setSelectedCategoryData([...listItems]);
      calculateTopCategoryData(listItems)
    }
    //  setFilteredData(prevState => {
    //    return [...listItems];
    //  });
  };

  const getTagsList = () => {
    apiManager
      .get(tagsListAPI)
      .then(response => {
        setTagsList(response.data.data.taxonomy);
      })
      .catch(error => {
        console.log("error", error);
      });
  };

  const getCategoryTagsList = (value) => {
    console.log(categoryTagsListAPI + value,'ategoryTagsListAPI')
    apiManager
      .get(categoryTagsListAPI + value)
      .then(response => {
        console.log(response.data.data.taxonomy,response.data,'response.data.data.taxonomy')
        setTagsList(response.data.data.taxonomy);
      })
      .catch(error => {
        console.log("error", error);
      });
  };

  const calculateFilteredData = data => {
    console.log(data, 'dataaa new');
    setCurrPage(1);
    
    const totalPages = Math.ceil(data.length / perPage);
    setTotalNumberOfPages(totalPages);
    const offset = 1 * perPage - perPage;
    const blogToShow = data.slice(offset, offset + perPage);
    // console.log(blogToShow, 'blogs to show' ,data,offset,perPage);
    setFilteredData(data);
    setBlogsToShow(blogToShow);
    
  };


  const calculateTopBlogsAll = data => {
    setPostDataAll([...data]);
    setSelectedCategoryData([...data]);
    console.log(data, 'allblogslist')
    let betterSpacesIndex30 = null;   // index of highest better spaces post count in past 30 days 
    let livingTogetherIndex30 = null;
    let betterLivingIndex30 = null;

    let betterSpacesIndex60 = null;   // //index of highest better spaces post count in past 60 days
    let livingTogetherIndex60 = null;
    let betterLivingIndex60 = null;

    data.map((blog, index) => {
      if (blog.categories && Array.isArray(blog.categories)) {
        const result = blog.categories.filter(
          elm =>
            elm.replaceAll(" ", "-").toLowerCase() ===
            "better-spaces"
        );

        if (result.length > 0) {
          if ((blog.brand_plug == "true" && blog.trending_plug == "true") && (betterSpacesIndex30 === null || blog.post_count_30 > data[betterSpacesIndex30].post_count_30)) {
            betterSpacesIndex30 = index;
          }

          else if ((blog.brand_plug == "true" && blog.trending_plug == "false") && (betterSpacesIndex60 === null || blog.post_count_60 > data[betterSpacesIndex60].post_count_60)) {
            betterSpacesIndex60 = index;
          }
        }

        const result1 = blog.categories.filter(
          elm =>
            elm.replaceAll(" ", "-").toLowerCase() ===
            "living-together"
        );
        if (result1.length > 0) {
          if ((blog.brand_plug == "true" && blog.trending_plug == "true") && (livingTogetherIndex30 === null || blog.post_count_30 > data[livingTogetherIndex30].post_count_30)) {
            livingTogetherIndex30 = index;
          }

          else if ((blog.brand_plug == "true" && blog.trending_plug == "false") && (livingTogetherIndex60 === null || blog.post_count_60 > data[livingTogetherIndex60].post_count_60)) {
            livingTogetherIndex60 = index;
          }

        }

        const result2 = blog.categories.filter(
          elm =>
            elm.replaceAll(" ", "-").toLowerCase() ===
            "better-living"
        );
        if (result2.length > 0) {
          if ((blog.brand_plug == "true" && blog.trending_plug == "true") && (betterLivingIndex30 === null || blog.post_count_30 > data[betterLivingIndex30].post_count_30)) {
            betterLivingIndex30 = index;
          }

          else if ((blog.brand_plug == "true" && blog.trending_plug == "false") && (betterLivingIndex60 === null || blog.post_count_60 > data[betterLivingIndex60].post_count_60)) {
            betterLivingIndex60 = index;
          }
        }
      }
    });

    const top6Blog = [data[betterSpacesIndex30], data[betterLivingIndex30], data[livingTogetherIndex30],
      data[betterSpacesIndex60], data[betterLivingIndex60], data[livingTogetherIndex60]];

    const removeBlogFromIndex = [betterSpacesIndex30, betterLivingIndex30, livingTogetherIndex30,
      betterSpacesIndex60, betterLivingIndex60, livingTogetherIndex60];

    removeBlogFromIndex.sort((a, b) => b - a).forEach((index) => {
      data.splice(index, 1);
    });
    const newTempArr = [...top6Blog, ...data].filter(element => element !== null);
    calculateFilteredData(newTempArr);
  }

  const getAllBlogList = () => {
    apiManager
      .get(AllCategoryBlogAPI)
      .then(response => {
        const {data} = response.data;
        const dataSliced = data.slice(1);
        if (props.isFromTagsLandingPage && props.tagName) {
          const listItems = [];
          dataSliced.map(blog => {
            if (blog.tags && Array.isArray(blog.tags)) {
              const result = blog.tags.filter(
                elm =>
                  elm.replaceAll(" ", "-").toLowerCase() ===
                  props.tagName.replaceAll(" ", "-").toLowerCase()
              );
              if (result.length > 0) {
                listItems.push(blog);
              }
            }
          });
          calculateFilteredData(listItems);
          setPostDataAll(listItems);
        }
        else if(props.isFromCategoryPage){
          console.log("inside else");
          setPostDataAll(dataSliced);
        }else{
          calculateTopBlogsAll(dataSliced);
        }
      })
      .catch(error => { });
  };

  const updatePageNumber = updatedPageNo => {
    setCurrPage(updatedPageNo);

    const offset = updatedPageNo * perPage - perPage;
    const blogToShow = filteredData.slice(offset, offset + perPage);
    setBlogsToShow(blogToShow);
  };

  useEffect(() => {
    if (!props.isTrendingBlogs) {
      getAllBlogList();
      getTagsList();
    }
  }, []);



  const getCategoryList = () => (
    <>
      <div
        className={`category ${selectedCategory == "All" ? "active-category" : ""
        }`}
        key="category-all"
        id="all"
        onClick={() => selectCategory("All")}
      >
          All
      </div>
      {!!props.categoryNameList &&
          props.categoryNameList.map((categoryName, index) => (
            <div
              className={`category ${selectedCategory == categoryName ? "active-category" : ""
              }`}
              key={`category-${index}`}
              id={categoryName + index}
              onClick={() => selectCategory(categoryName)}
            >
              {categoryName}
            </div>
          ))}
    </>
  );

  const addRemoveTag = tag => {                 // this is called when tags are added or removed
    const tagIndex = selectedTagList.indexOf(tag);   // checks bn
    const tempTagList = [...selectedTagList];
    if (tagIndex == "-1") {
      tempTagList.push(tag);
      setSelectedTagList(tempTagList);
    } else {
      tempTagList.splice(tagIndex, 1);
      setSelectedTagList(tempTagList);
    }

    const newFilteredData = [];
    if (tempTagList.length < 1) {
      filterByCategory(selectedCategory);
    } else {
      console.log(selectedCategoryData, 'selectedCategoryData');
      for (let i = 0; i < selectedCategoryData.length; i++) {
        for (let j = 0; j < tempTagList.length; j++) {
          console.log(selectedCategoryData, 'selectedCategoryData')
          if (
            selectedCategoryData[i].tags &&
            Array.isArray(selectedCategoryData[i].tags)
          ) {
            const result = selectedCategoryData[i].tags.filter(
              elm => elm.toLowerCase() === tempTagList[j].toLowerCase()
            );
            if (result.length > 0) {
              newFilteredData.push(selectedCategoryData[i]);
              break;
            }
          }
        }
      }

      calculateTopCategoryData(newFilteredData);
    }
  };

  const selectSorting = (type) => {
    setSortingType(type)
    if (type == "ALL") {
      calculateFilteredData(filteredData);

    }
    else if (type == "MOST RECENT") {
      const currData = postDataAll;
      currData.sort((a, b) => new Date(b.date) - new Date(a.date));
      console.log(currData, 'currData', postDataAll)
      calculateFilteredData(currData);
    }
    else if (type == "MOST POPULAR") {
      const currData = postDataAll;
      currData.sort((a, b) => a.post_count - b.post_count);
      calculateFilteredData(currData);
    }

  }

  return (
    <div className="explore-more-container">
      <div className="explore-more-top">
        {props.isFromTagsLandingPage ? <div className="categories">
          {/* <div
            className={`category ${sortingType == "ALL" ? "active-category" : ""
              }`}
            key={`category-all`}
            id="all"
            onClick={() => selectSorting("ALL")}
          >
            All
        </div> */}
          <div
            className={`category ${sortingType == "MOST RECENT" || sortingType == "ALL" ? "active-category" : ""
            }`}
            key="category-all"
            id="all"
            onClick={() => selectSorting("MOST RECENT")}
          >
            MOST RECENT
          </div>
          <div
            className={`category ${sortingType == "MOST POPULAR" ? "active-category" : ""
            }`}
            key="category-all"
            id="all"
            onClick={() => selectSorting("MOST POPULAR")}
          >
            MOST POPULAR
          </div>
        </div> : props.isFromCategoryPage ? (
          <>
            <div className="more-from">More from</div>
            <div className="categories">

              <div
                className="category active-category"
                key="category-all"
                id="selected-category"
              >
                {props.categoryName.replaceAll("-", " ").toUpperCase()}
              </div>
            </div>
            <div className="h-line" />
          </>
        ) : props.isTrendingBlogs ? (<><div className="heading trending-title">Trending</div></>) : (
          <>
            <div className="heading">Explore More</div>
            <div className="categories">
              {!!props.categoryNameList && getCategoryList()}
            </div>
            <div className="h-line" />
          </>
        )}
        {!props.isTrendingBlogs && !props.isFromTagsLandingPage &&
          <div className="tags">
            {!!tagsList && tagsList.length > 0 &&
              tagsList.map((tag, index) => (
                <div
                  className={`tag ${selectedTagList.includes(tag) ? "active-tag" : ""
                  }`}
                  key={`category-${index}`}
                  id={tag + index}
                  onClick={() => addRemoveTag(tag)}
                >
                  {tag}
                </div>
              ))}
          </div>}
      </div>
      <div className="explore-more">
        <div className="blog-container">
          <CategoryData
            blogList={props.isTrendingBlogs ? props.trendingBlogs : blogToShow}
          />
        </div>

        <div className="pagination">
          <Pagination
            numberOfPages={totalNumberOfPages}
            currentPage={currPage}
            updatePageNumberCallback={updatePageNumber}
            homeImages={props.homeImages}
          />
        </div>
      </div>
    </div>
  );
}

export default ExploreMore;
